import FeatureRequestIssueBadge from "@/src/components/feature-requests/feature-request-issue-badge";
import BlocksAvatar from "@/src/components/ui-kit/blocks-avatar";
import { FeatureRequest } from "@/src/models/feature-request.model";
import { Pressable, Text, View } from "react-native";

type FeatureRequestCardProps = Readonly<{
  request: FeatureRequest;
  onPress: (request: FeatureRequest) => void;
}>;

export default function FeatureRequestCard({
  request,
  onPress,
}: FeatureRequestCardProps) {
  const author = request.authorSnapshot;

  return (
    <Pressable
      onPress={() => onPress(request)}
      className="gap-2 p-3 bg-chalk rounded-2xl border border-ash-3 shadow-sm shadow-shadow-light hover:border-primary-1"
    >
      <Text className="text-sm font-semibold text-onyx" numberOfLines={2}>
        {request.title}
      </Text>
      {!!request.description && (
        <Text className="text-sm text-slate" numberOfLines={2}>
          {request.description}
        </Text>
      )}
      <View className="flex-row items-center justify-between">
        <BlocksAvatar
          userId={request.CreatedBy}
          fallbackImageUrl={author?.profileImageUrl}
          firstName={author?.firstName}
          lastName={author?.lastName}
          size={28}
        />
        <FeatureRequestIssueBadge request={request} />
      </View>
    </Pressable>
  );
}
